module.exports = __webpack_public_path__ + "static/media/spacex1.58c2f743.png";